import axios from 'axios'
import { getSavedState, saveState } from '../store-utils'

export const state = {
  cachedCycles: getSavedState('device.cycles'),
  selectedCycle: null,
}

export const getters = {
  cachedCycles(state) {
    return state.cachedCycles
  },
  selectedCycle(state) {
    return state.selectedCycle
  },
}

export const mutations = {
  SET_CACHE(state, cycles) {
    state.cachedCycles = cycles
    saveState('device.cycles', cycles)
  },
  SET_SELECTED(state, cycle) {
    state.selectedCycle = cycle
  },
}

export const actions = {
  selectCycle({ commit, state, rootState }, { cycle }) {
    commit('SET_SELECTED', cycle)
  },

  fetchCycles({ commit, state, rootState }, { clearCache, deviceId, dateRange }) {
    // 1. Check if we've already fetched and cachedGroups the cycle groups.
    const matchedCycles = state.cachedCycles

    if (!clearCache && matchedCycles) {
      return Promise.resolve(matchedCycles)
    }
    let url

    if (dateRange) {
      // 2. Fetch the cycles from the API and cache it in case
      // we need it again in the future.
      url =
        '/api/services/app/DeviceCycle/GetAll' +
        '?StartDate=' +
        dateRange.start +
        '&EndDate=' +
        dateRange.end
    } else {
      url = '/api/services/app/DeviceCycle/GetAll'
    }
    if (deviceId) {
      url = url + '&DeviceId=' + deviceId
    }
    return axios
      .get(url)
      .then((response) => {
        const cycles = response.data.items
        commit('SET_CACHE', cycles)
        return cycles
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          this.$router.push('Login')
        }
        return null
      })
  },

  updateCycle({ commit, dispatch, state, rootState }, { cycle }) {
    return axios
      .put('/api/services/app/DeviceCycle/Update', cycle)
      .then((response) => {
        dispatch('fetchCycles', { clearCache: true }).then((resp) => {
          commit('SET_SELECTED', null)
        })
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },
}
